import { h, Component } from 'preact';
import Store from 'store/store';
import QuizPhotobooth from 'components/bolt/quizPhotobooth/quizPhotobooth';
import { joinClasses } from 'utils/utils';
import s from 'components/bolt/showtimes/creativeSpace.sss';
import 'store/bolt/creativeSpace';

export default class creativeSpace extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loaded: false,
		};
		this.handleClick = this.handleClick.bind(this);
		this.handleImageLoaded = this.handleImageLoaded.bind(this);
	}

	handleClick() {
		this.props.toggleMoveDown();
		if (!this.props.activated) {
			Store.emit('TRACK_CREATIVE_SPACE_ACTIVATION');
		} else {
			Store.emit('TRACK_CREATIVE_SPACE_DEACTIVATION');
		}
	}

	handleImageLoaded() {
		this.setState({ loaded: true });
	}

	// container for the photobooth and the button that returns to showtimes
	renderContainer() {
		const appData = Store.get().appData;
		const data = appData.pages.boltQuizPhotobooth.data;
		const client = Store.get().client;
		return this.state.loaded && (
			<div class={s.container}>
				<QuizPhotobooth creativeSpace data={data} appData={appData} client={client} />
				<button
					class={joinClasses(s.dropButton, !this.props.activated && s.hidden)}
					onClick={this.handleClick}
				>BACK TO SHOWTIMES
				</button>
			</div>
		);
	}

	// image that fades out when clicked to reveal the photobooth
	// fades back in when button is clicked to return to showtimes
	renderFadeOut() {
		const isSmallDesktop = Store.get().client.dimensions.width > 1024;
		const isDualColumn = isSmallDesktop && Store.get().client.orientation === 'landscape';
		return (
			<div class={s.fadeOut}>
				<img
					class={joinClasses(s.img, this.props.activated && s.activated)}
					onClick={!this.props.activated && this.handleClick}
					onLoad={this.handleImageLoaded}
					src={isDualColumn ? this.props.data.imageDesktop : this.props.data.imageMobile}
					alt=""
				/>
			</div>
		);
	}

	render() {
		return (
			<div class={s.creativeSpace}>
				{this.renderContainer()}
				{this.renderFadeOut()}
			</div>
		);
	}
}